import React from 'react'
import PropTypes from 'prop-types'

function SuccessMessage({ subscribed, modified }) {
  return (
    <div className="Notification Notification--withIcon Notification--confirm u-marginBottom3gu u-animFadeInUp">
      {(subscribed || !modified) && (
        <div className="Notification-content">
          Success! You are subscribed to this product.
        </div>
      )}

      {modified && (
        <div className="Notification-content">
          Your subscription preferences have been updated.
        </div>
      )}
    </div>
  )
}

SuccessMessage.propTypes = {
  subscribed: PropTypes.bool,
  modified: PropTypes.bool,
}

export default SuccessMessage
